module.exports = {
  entry: './src/apps/leadership-assessment/index.tsx',
  shortcode: 'leadership-assessment',
  title: 'Leadership Assessment',
  status: 'stable',
  description:
    'leadership (Responsible AI Maturity Assessment) widget which does an assessment to help companies visualize their areas of strength regarding Responsible AI.',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-leadership-assessment-components--default&viewMode=story`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/products'],
    availableTranslations: ['en'],
  },
};
